<template>
	<div class="userDetail">
		<div class="contain">
			<div class="title"></div>
			<div class="content">
				<div class="left">
					<div class="left-top">
						<div class="top-header">
							<img class="header-img" :src="require('@/assets/user/header.png')" alt="">
							<!-- <img v-if='vipImg' class="header-vip" :src="require('@/assets/user/'+vipImg)" alt=""> -->
						</div>
						<input class="name" type="text" :disabled="!isEdit" :class="{'name-edit':isEdit}" v-model="nickName" maxlength="12"/>
						<p class="phone">{{userInfo.phone2}}</p>
						<button class="bg-yellow" @click="isEdit=true;" v-if="!isEdit">编辑资料</button>
						<!-- <button class="bg-black color-yellow" v-if="!isEdit" @click='openRecharge();'>{{userInfo.vip_type ===0?'成为VIP':'升级VIP'}}</button> -->
						<button class="bg-yellow" v-if="isEdit" @click="sureEdit">确定</button>
						<button class="cancle-btn" @click="editData()" v-if="isEdit">取消</button>
					</div>
					<div class="left-select">
						<ul>
							<li v-for="(item,index) of menu.item" :key="index" v-show='item.title!="使用记录"'  :class="{'is-select':menu.menuSelectIndex==index}" @click="menuSelectClick(index)">{{item.title}}</li>
						</ul>
					</div>
				</div>
				<div class="vip-center" v-show="menu.menuSelectIndex==0">
					<div class="center-level">
						<div class="first" v-if="free_time > 0">
							<img :src="require('@/assets/user/v2.png')">
							<p class="title">畅玩会员</p>
							<p class="time">有效期 {{free_time | fitlerTimeDay}} 天</p>
							<button @click="openRecharge()">立即续费</button>
						</div>
						<div class="first2" v-if="!free_time">
							<img :src="require('@/assets/user/v.png')">
							<p class="title">畅玩会员</p>
							<p class="time">不限游戏时长任意玩</p>
							<button @click="openRecharge()">立即开通</button>
						</div>
						<div class="two">
							<p class="title">剩余时长</p>
							<p class="time">{{tota_time | fitlerTimeHour}}<span> 小时</span> {{tota_time | fitlerTimeMin}}<span> 分</span></p>
							<button @click="openRecharge()">立即续时</button>
						</div>
					</div>
					<div class="privilege-part">
						<p class="privilege-title">会员特权：</p>
						<div class="privilege-group">
							<div class="privilege-item" v-for="(item,index) of privilege"  :key="index" >
								<p class="item-title" >{{item.title}}</p>
								<span class="item-line"></span>
								<div class="item-txt">
									<p>{{item.txt}}</p>
									<p class="txt-strong">
										{{item.des}}
										<span v-if="item.through">{{item.through}}</span>
									</p>
								</div>
							</div>
						</div>
					</div>	
				</div>
				<div class="vip-right" v-show="false">
					<div class="right-top">
						<p class="money-txt">胖哒云游币余额：</p>
						<div class="money">
							<img :src="require('@/assets/user/coin.png')" alt="">
							<span>{{myCoin}}</span>	
						</div>
						<button class="bg-yellow" @click='openRecharge()'>余额充值</button>
						<button class="bg-black color-yellow" @click='duihuanDialogShow=true;'>兑换胖哒云游币</button>
					</div>
				</div>
		
				<div class="order" v-show="menu.menuSelectIndex==1">
					<div class="order-select">
						<ul>	
							<li :class="{'is-select':orderType.orderSelectIndex==index}" v-for="(item,index) of orderType.type" :key="index" @click="selectOrderType(index)">{{item.name}}</li>
						</ul>
					</div>
					<div class="order-table">
						<el-table
							:data="orderTable"
							:row-class-name="tableRowClassName"
							cell-class-name='cell-class'
							header-row-class-name="header-row"
							style="width: 100%;height:520px;" max-height='520'
							>
							<el-table-column
								prop="order_number"
								label="订单编号"
								width="240"
								height="64"
								align="center">
							</el-table-column>
							<el-table-column
								prop="product_price"
								label="充值金额"
								width="150"
								align="center">
								<template slot-scope="scope">
									<span >{{scope.row.product_price}}元</span>
								</template>
							</el-table-column>
							<el-table-column
								prop="create_time"
								label="充值时间"
								width="250"
								align="center">
								<template slot-scope="scope">
									<span >{{scope.row.create_time.split("+")[0].split("T").join(" ")}}</span>
								</template>
							</el-table-column>
							<el-table-column
								prop="order_status"
								label="支付状态"
								width="80"
								:formatter="formatStatus"
								class-name="has-pay"
								label-class-name="label-class-name"
								align="center"
								>
								<template slot-scope="scope">
									<span :class="{'no-pay':scope.row.order_status==2}" class="">{{scope.row.order_status==2?'已付款':'待付款'}}</span>
								</template>
							</el-table-column>
							<el-table-column
								fixed="right"
								label="操作"
								width="220"
								label-class-name="handle-label">
								<template slot-scope='scope'>
									<button class="table-btn bg-yellow" @click='orderPay(scope.row)' v-show='scope.row.order_status!=2'>
										立即付款
									</button>
									<button class="table-btn bg-yellow" @click='orderPay2(scope.row)' v-show='scope.row.order_status==2'>
										再次购买
									</button>
									<button class="table-btn bg-transparent" @click='shanchuItem = scope.row;scOrderDialogShow = true;'>删除订单</button>
								</template>
							</el-table-column>
						</el-table>
						<el-pagination
						  class='fenye'
						  small background
						  layout="prev, pager, next"
						  :total="orderTableTotal"
						  @current-change="handleCurrentChange" @prev-click='prevPage' @next-click='nextPage'>
						</el-pagination>
					</div>
				</div>
				
				
				<div class="record" v-show='menu.menuSelectIndex==2'>
					<el-table
						header-row-class-name='header-row'
						cell-class-name='cell-class'
					    :data="recordData"
					    stripe
					    style="width: 100%;height:570px;" max-height='570'>
					    <el-table-column
					      prop="client_dev_type"
					      label="使用类型"
						  width="277"
						  align="center">
						  <template slot-scope='scope'>
							  <div v-show='scope.row.client_dev_type === 1'>Windows客户端</div>
							  <div v-show='scope.row.client_dev_type === 2'>MAC客户端</div>
							  <div v-show='scope.row.client_dev_type === 3||scope.row.client_dev_type === 0'>安卓客户端</div>
							  <div v-show='scope.row.client_dev_type === 4'>iOS客户端</div>
							  <div v-show='scope.row.client_dev_type === 5'>Linux客户端</div>
							  <div v-show='scope.row.client_dev_type === 6'>WEB客户端</div>
						  </template>
					    </el-table-column>
					    <el-table-column
					      prop="connect_time"
					      label="开始时间"
						  width="277"
						  align="center">
					    </el-table-column>
					    <el-table-column
					      prop="disconnect_time"
					      label="结束时间"
						  width="277"
						  align="center">
					    </el-table-column>
						<el-table-column
						  prop="used_coin"
						  label="消费数量"
						  align="center">
						</el-table-column>
					  </el-table>
					  <el-pagination
					    class='fenye'
					    small background
					    layout="prev, pager, next"
					    :total="recordDataTotal"
					    @current-change="handleCurrentChange2" @prev-click='prevPage2' @next-click='nextPage2'>
					  </el-pagination>
				</div>
				
				<div class="issue" v-show='menu.menuSelectIndex==3'>
					<div class="title">
						<div class="left">意见反馈</div>
						<div class="right">您的建议将帮助我们变得更好</div>
					</div>
					<div class="label">
						问题描述
					</div>
					<div class="text">
						<el-input
						  type="textarea"
						  :rows="9"
						  resize='none'
						  placeholder="请留下您宝贵的意见，我们将努力改进～"
						  maxlength="50"
						  show-word-limit
						  v-model="textarea">
						</el-input>
					</div>
					<div class="label" style='margin-top: 60px;'>
						问题截图
					</div>
					<div class="upload">
						<el-upload
						  ref='upload'
						  :action="uploadUrl"
						  :http-request='customUpload'
						  list-type="picture-card"
						  accept='.png, .jpg, .jpeg'
						  multiple
						  :limit='3'
						  :file-list='imgList'
						  :show-file-list='true'
						  :on-remove="handleRemove"
						  :on-success="handleAvatarSuccess"
						  :before-upload='handleBeforeUpload'>
						  <i class="el-icon-camera"></i>
						</el-upload>
					</div>
					<div class='btn'>
						<el-button round class='btns' @click='issueCommit'>提交</el-button>
					</div>
				</div>
			</div>
		</div>

		<my-footer></my-footer>

		<el-dialog :visible.sync="duihuanDialogShow" width="628px"  :close-on-press-escape='false' :show-close='false' :lock-scroll='false'
		 :close-on-click-modal='false' top='20vh'  class='duihuanDialog'>
			<template #title>
				<div  class="dialog_title">
					<div class="left">
						<el-image :src="require('@/assets/user/dhTitle.png')"></el-image>
					</div>
					<div class='mind'>
						兑换胖哒云游币
					</div>
				</div>
				<div class="closeRight">
					<div class="right_div"  @click="duihuanDialogShow=false;duihuanCode='';">
					</div>
				</div>
			</template>
			<div class="contain">
				<div class="text">
					<el-input v-model="duihuanCode" placeholder="请输入兑换码" style='width:100%;'></el-input>
				</div>
				<div class="btns">
					<el-button round class='btn1' @click="duihuanDialogShow=false;duihuanCode='';">取消</el-button>
					<el-button round class='btn2' @click='doDuiHuan'>兑换</el-button>
				</div>
			</div>
			<!-- 兑换成功的dialog -->
			<el-dialog width="420px" :visible.sync="duihuanSuccessShow"  append-to-body :show-close='false' top='30vh' >
				<div style="text-align: center;">
					<el-image style='width: 80px;height: 80px;vertical-align: middle;' :src="require('@/assets/user/dhSuccess.png')"></el-image>
				</div>
				<div style='color: rgba(13,13,13,1);text-align: center; font-size:24px;margin-top: 20px;'>
					兑换成功
				</div>
				<div style='color:rgba(109,114,120,1);text-align: center;font-size:18px !important;margin-top: 10px;'>
					小主，系统检查你已兑换成功。
				</div>
			</el-dialog>
			
			<!-- 兑换失败的dialog -->
			<el-dialog width="420px" :visible.sync="duihuanFailShow"  append-to-body :show-close='false' top='30vh' >
				<div style="text-align: center;">
					<el-image style='width: 80px;height: 80px;vertical-align: middle;' :src="require('@/assets/user/dhError.png')"></el-image>
				</div>
				<div style='color: rgba(13,13,13,1);text-align: center; font-size:24px;margin-top: 20px;'>
					兑换失败
				</div>
				<div style='color:rgba(109,114,120,1);text-align: center;font-size:18px !important;margin-top: 10px;'>
					小主，系统检查你已兑换失败。
				</div>
			</el-dialog>
		</el-dialog>
		
		
		<!-- 删除订单dialog -->
		<el-dialog :visible.sync="scOrderDialogShow" width="528px"  :close-on-press-escape='false' :show-close='false' :lock-scroll='false'
		 :close-on-click-modal='false' top='20vh'  class='scOrderDialog'>
			<div style='text-align: center;'>
				<el-image :src="require('@/assets/user/shanchuBG.png')" style='width: 220px;height: 220px;vertical-align: middle;margin-top: 20px;'></el-image>
			</div>
			<div style='text-align: center;'>
				<div style='font-size:24px;color:rgba(13,13,13,1);margin-top: 40px;'>
					小主，确定是要删除该订单吗？
				</div>
			</div>
			<div style='text-align: center;margin-bottom: 20px;'>
				<div class="btns">
					<el-button round class='btn1' @click="scOrderDialogShow=false;">取消</el-button>
					<el-button round class='btn2' @click='shanchuOrder'>确定</el-button>
				</div>
			</div>
		</el-dialog>
		
		<!-- 问题反馈dialog -->
		<el-dialog :visible.sync="issueDialogShow" width="528px"  :close-on-press-escape='false' :show-close='false' :lock-scroll='false'
		 :close-on-click-modal='false' top='20vh'  class='issueDialog'>
			<div style='text-align: center;'>
				<el-image :src="require('@/assets/user/issueBG.png')" style='width: 220px;height: 220px;vertical-align: middle;'></el-image>
			</div>
			<div style='text-align: center;'>
				<div style='font-size:24px;color:rgba(13,13,13,1);font-family:MicrosoftYaHei;line-height:40px;width:422px;margin: 35px auto 0 auto;'>
					小主，感谢你所提交的宝贵意见，我们的产品将会不断的改善～
				</div>
			</div>
			<div style='text-align: center;'>
				<div class="btns">
					<el-button round class='btn2' @click='issueClose()'>确定</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import Vue from 'vue';
	import axios from 'axios';
	import MyFooter from '@/components/footer';
	import {Table,TableColumn,Pagination,
	Upload,Message,} from 'element-ui';
	Vue.use(Table).use(TableColumn).use(Pagination)
	.use(Upload);
	export default{
		name:'userDetail',
		components:{
			MyFooter
		},
		filters:{
			fitlerTimeHour (val) {
				return parseInt(val/3600)
			},
			fitlerTimeMin (val) {
				return parseInt(val%3600/60)
			},
			fitlerTimeDay(val){
				return parseInt(val/3600/24)
			}
		},
		data(){
			return{
				tota_time:"",
				free_time:JSON.parse(sessionStorage.getItem('userInfo')).free_time || '',
				vip:[
					{
						level:0,
						group:0,
						levelImg:"level0.png"
					},{
						level:1,
						group:270,
						levelImg:"level1.png"
					},{
						level:2,
						group:810,
						levelImg:"level2.png"
					},{
						level:3,
						group:2430,
						levelImg:"level3.png"
					},{
						level:4,
						group:7290,
						levelImg:"level4.png"
					},{
						level:5,
						group:21870,
						levelImg:"level5.png"
					},{
						level:6,
						group:65610,
						levelImg:"level6.png"
					},{
						level:7,
						group:196830,
						levelImg:"level7.png"
					},{
						level:8,
						group:590490,
						levelImg:"level8.png"
					}
				],
				privilege:[
					{
						title:"会员上机折扣",
						txt:"会员上机每小时",
						des:"300胖哒云游币",
						through:"",
						bg:"img/person-center/power-bg1.png"
					},
					{
						title:"会员游戏特权",
						txt:"会员用户可享受",
						des:"不同游戏专属特权",
						bg:"img/person-center/power-bg2.png"
					},
					{
						title:"会员排队优先",
						txt:"会员用户优先排队",
						des:"减少等待时间",
						bg:"img/person-center/power-bg3.png"
					},
					{
						title:"会员配置选择",
						txt:"会员用户可优先选择",
						des:"机器配置",
						bg:"img/person-center/power-bg4.png"
					},
					{
						title:"会员节日活动",
						txt:"会员用户可享受不同的",
						des:"回馈与活动",
						bg:"img/person-center/power-bg5.png"
					},
					{
						title:"会员客服优先",
						txt:"会员用户可享受",
						des:"专属客服服务",
						bg:"img/person-center/power-bg6.png"
					}
				],
				menu:{
					menuSelectIndex:0,
					item:[
						{
							title:"会员特权"
						},
						{
							title:"充值订单"
						},
						{
							title:"使用记录"
						},
						{
							title:"意见反馈"
						}
					]
				},
				isEdit:false,
				userInfo:{},
				vipImg:"",
				fullWidth:0,
				subGroup:0,
				nickName:"",
				ProductsList:[],
				Paymen:'',
				choseItem:{},
				orderTable:[],
				orderTableTotal:0,
				orderType:{
					orderSelectIndex:0,
					type:[
						{name:"全部订单"},
						{name:"已付款订单"},
						{name:"待付款订单"}
					]
				},
				pageNum:1,
				duihuanDialogShow:false,
				duihuanCode:'',
				duihuanSuccessShow:false,
				duihuanFailShow:false,
				
				scOrderDialogShow:false,
				shanchuItem:{},
				
				recordData:[],
				recordDataTotal:0,
				pageNum2:1,
				
				textarea:'',
				imgList:[],
				issueDialogShow:false,
				uploadUrl:'https://api-bs.tlhcxm.top/api/v1/cloud_pc/upload',
				suspensionShow:false,
				mrLeft:0,
				mrTop:0,
				
				isAppShow:false,
				myCoin:0
			}
		},
		created() {
			let that = this;
			that.$utils.checkBrowser();
			if(!that.$utils.checkLogin()){
				that.$router.replace('/')
				return;
			}
		},
		mounted() {
			let that = this;
			that.$bus.$emit('setHeadColor','#000');
			that.getLoginInfo();
			that.getProducts();

			that.$bus.$on('getLogin',()=>{
				// 支付成功重新获取用户信息
				that.getLoginInfo();
			});
			this.tota_time = JSON.parse(sessionStorage.getItem('userInfo')).tota_time
		},
		methods:{
			menuSelectClick(key){
				let that = this;
				that.menu.menuSelectIndex=key;
				if(key==0){
					that.getLoginInfo()
				}else if(key == 1){
					that.getOrder();
				}else if(key == 2){
					that.getRecord();
				}
			},
			editData(){
				let that = this;
				that.isEdit = false;
				that.nickName = that.userInfo.nick_name;
			},
			
			getLoginInfo() {
				let that = this;
				let url = 'api/v1/cloud_pc/app/user_info';
				that.$req.post(url, {})
					.then(res => {
						if (res.data) {
							that.userInfo=res.data;
							let str = res.data.phone;
							that.userInfo.phone2 = str.substr(0,3)+'****'+str.substr(7,str.length);
							that.vipImg = "vip"+that.userInfo.vip_level+".png";
							that.nickName=that.userInfo.nick_name
							that.myCoin=that.userInfo.my_coin - that.userInfo.used_coin + that.userInfo.cy_count;

							let obj = res.data;
							
							obj.phone2 = str.substr(0,3)+'****'+str.substr(7,str.length);
							obj.surplus_coin = res.data.my_coin - res.data.used_coin + res.data.cy_count;
							obj.tota_time = obj.surplus_coin/5*60
							that.usreInfo = obj;
							that.$set(that.usreInfo,obj);
							// that.$bus.$emit("getUserInfo",that.usreInfo)
							Vue.prototype.GetUserInfo=that.usreInfo
							sessionStorage.setItem('userInfo',JSON.stringify(res.data));

							this.tota_time = JSON.parse(sessionStorage.getItem('userInfo')).tota_time
							this.free_time = JSON.parse(sessionStorage.getItem('userInfo')).free_time
							// if(that.userInfo.vip_level>0){
							// 	if(that.userInfo.vip_level == 8){
							// 		let preLeft= that.$refs.tiao[6].offsetLeft;
							// 		let nextLeft = document.querySelector('.level-tiao').offsetWidth;
							// 		let preGroup=that.vip[that.userInfo.vip_level-1].group;
							// 		let nextGroup = 590490;
							// 		let thisGroup=that.userInfo.growth_value
							// 		that.fullWidth=preLeft+((nextLeft-preLeft)/(nextGroup-preGroup)*(thisGroup-preGroup))
							// 		// console.info(that.fullWidth)
							// 	}if(that.userInfo.vip_level == 7){
							// 		let preLeft= that.$refs.tiao[that.userInfo.vip_level-1].offsetLeft
							// 		let nextLeft = document.querySelector('.level-tiao').offsetWidth;
							// 		let preGroup=that.vip[that.userInfo.vip_level].group
							// 		let nextGroup = that.vip[that.userInfo.vip_level+1].group
							// 		let thisGroup=that.userInfo.growth_value
							// 		that.subGroup=nextGroup-thisGroup
							// 		that.fullWidth=preLeft+((nextLeft-preLeft)/(nextGroup-preGroup)*(thisGroup-preGroup))
							// 	}else{
							// 		let preLeft=that.$refs.tiao[that.userInfo.vip_level-1].offsetLeft
							// 		let nextLeft=that.$refs.tiao[that.userInfo.vip_level].offsetLeft
							// 		let preGroup=that.vip[that.userInfo.vip_level].group
							// 		let nextGroup=that.vip[that.userInfo.vip_level+1].group
							// 		let thisGroup=that.userInfo.growth_value
							// 		that.subGroup=nextGroup-thisGroup
							// 		that.fullWidth=preLeft+((nextLeft-preLeft)/(nextGroup-preGroup)*(thisGroup-preGroup))
							// 	}
							// }else{
							// 	let preLeft= 0;
							// 	let nextLeft=that.$refs.tiao[0].offsetLeft;
							// 	let preGroup = 0;
							// 	let nextGroup = 270;
							// 	let thisGroup=that.userInfo.growth_value;
							// 	that.subGroup=nextGroup-thisGroup
							// 	that.fullWidth=preLeft+((nextLeft-preLeft)/(nextGroup-preGroup)*(thisGroup-preGroup));
							// }
						} 
					})
					.catch(err => {
						console.log(err);
					})
			},
			sureEdit(){
				let that = this;
				if(that.nickName==""){
					Message.warning('名字不能为空')
					return 
				}
				if(that.nickName == that.userInfo.nick_name)return that.isEdit=false;
				let url = 'api/v1/cloud_pc/app/user_info_update';
				that.$req.post(url, {
						nick_name:that.nickName
					})
					.then(res => {
						if(res.code === 0){
							Message.success('修改成功')
							that.userInfo.nick_name=that.nickName
							that.isEdit=false
						}else{
							Message.warning('修改失败')
						}
					}).catch(err=>{
						console.error(err);
					})
			},
			getOrder(){
				let that = this;
				let url = 'api/v1/cloud_pc/app/my_order';
				let order_status = null;
				if(that.orderType.orderSelectIndex === 0){
					// 全部
					order_status = -1;
				}else if(that.orderType.orderSelectIndex == 1){
					// 已付款
					order_status = 2;
				}else{
					// 待付款
					order_status = 1;
				}
				that.$req.post(url, {
						index:that.pageNum,
						num:8,
						order_status:order_status
					})
					.then(res => {
						that.orderTable = res.data;
						that.orderTableTotal = res.info.total;

					}).catch(err=>{
						console.log(err)
					})
			},
			getRecord(){
				let that = this;
				let url = 'api/v1/cloud_pc/list_record';
				let data = {
					index: that.pageNum2,
					num: 8,
					user_id: that.userInfo.user_id||''
				};
				that.$req.post(url, data, )
					.then(res => {
						// console.info(res)
						if (res.code === 0) {
							let arr = res.data;
							that.recordData = [...arr];
							that.recordDataTotal = res.info.total;
						} 
					})
					.catch(err => {
						Message(err);
					})
				
			},
			selectOrderType(key){
				let that = this;
				that.orderType.orderSelectIndex=key;
				that.pageNum = 1;
				that.orderTableTotal = 0;
				that.getOrder();
				
			},
			tableRowClassName({row, rowIndex}){
				if(rowIndex%2!==1){
					return 'odd-li'
				}else{
					return 'even-li'
				}
			},
			formatStatus(row, column){
				if(row.order_status==1){
					return "待付款"
				}else if(row.order_status==2){
					return "已付款"
				}else if(row.order_status==3){
					return "已退款"
				}
			},
			// 打开充值框
			openRecharge(productObj){
				let that = this;
				let item = productObj?productObj:null;
				that.$bus.$emit('RechargeDialogShow',true,item);
			},
			// 获取充值套餐
			getProducts() {
				let that = this;
				let url = 'api/v1/cloud_pc/app/product/list';
				that.$req.post(url, {
						product_type: 0
					})
					.then(res => {
						if (res.code === 0 && res.data) {
							let arr = res.data;
							that.ProductsList = [...arr];
							
						} else {
							Message.error(res.msg);
						}
					})
					.catch(err => {
						console.error(err);
					})
			},

			// 兑换业务
			doDuiHuan(){
				let that = this;
				if(!that.duihuanCode){
					Message.warning("兑换码不能为空")
					return 
				}
				let url = 'api/v1/cloud_pc/app/convert_cdkey';
				let data = {
					"cdkey_code":that.duihuanCode
				};
				
				that.$req.post(url,data)
				.then(res=>{
					// console.info(res)
					if(res.code === 0){
						that.duihuanSuccessShow = true;
						setTimeout(()=>{
							that.getLoginInfo();
							that.duihuanSuccessShow = false;
							that.duihuanDialogShow = false;
							that.duihuanCode = '';
						},2000)
					}else{
						Message.error(res.msg)
						that.duihuanFailShow = true;
						setTimeout(()=>{
							that.getLoginInfo();
							that.duihuanFailShow = false;
							that.duihuanDialogShow = false;
							that.duihuanCode = '';
						},2000)
					}
				})
				.catch(err=>{
					Message.error(err)
				})
			},
			handleCurrentChange(val){
				let that = this;
				that.pageNum = val;
				that.getOrder();
			},
			prevPage(val){
				let that = this;
				that.pageNum = val;
				that.getOrder();
			},
			nextPage(val){
				let that = this;
				that.pageNum = val;
				that.getOrder();
			},
			handleCurrentChange2(val){
				let that = this;
				that.pageNum2 = val;
				that.getRecord();
			},
			prevPage2(val){
				let that = this;
				that.pageNum2 = val;
				that.getRecord();
			},
			nextPage2(val){
				let that = this;
				that.pageNum2 = val;
				that.getRecord();
			},
			shanchuOrder(){
				let that = this;
				// that.shanchuItem
				let url = 'api/v1/cloud_pc/app/pay/hide_order';
				let data = {
					order_number:that.shanchuItem.order_number
				};
				that.$req.post(url,data)
				.then(res=>{
					// console.info(res)
					if(res.code ===0){
						Message.success('删除成功.');
						that.scOrderDialogShow = false;
						that.getOrder();
					}else{
						Message(res.msg)
					}
				})
				.catch(err=>{
					// console.info(err);
					Message.error(err);
				})
			},
			// 立即付款
			orderPay(item){
				let that = this;
				// console.info(item);
				that.ProductsList.map((k,v)=>{
					if(k.id == item.product_id){
						that.choseItem = k;
					}
				});
				that.Paymen = item.pay_type;
				that.openRecharge(that.choseItem);
				let url = 'api/v1/cloud_pc/app/pay/hide_order';
				let data = {
					order_number:item.order_number
				};
				that.$req.post(url,data)
				.then(res=>{
					
					if(res.code ===0){
						that.getOrder();
					}
				})
			},
			// 再次购买
			orderPay2(item){
				let that = this;
				that.ProductsList.map((k,v)=>{
					if(k.id == item.product_id){
						that.choseItem = k;
					}
				});
				that.Paymen = item.pay_type;
				that.openRecharge(that.choseItem);
			},
			customUpload(request){
				let that = this;
				// console.info(request.file);
				let file = request.file;
				if(file.type != 'image/jpeg'&&file.type != 'image/jpg'&&file.type != 'image/png'){
					Message('请上传图片类型!')
					return;
				}
				if(file.size / 1024 / 1024 > 3){
					Message('图片大小需控制在3M以内!')
					return;
				}
				let url = request.action;
				let formData = new FormData();
				formData.append("file", file);
				formData.append('category','feedback')
				axios({
					method:'post',
					url:url,
					data:formData,
					headers:{
						'Content-Type':'multipart/form-data'
					}
				})
				.then(res=>{
					// console.info(res)
					if(res.data.code === 0){
						that.imgList.push({name:request.file.name,url:res.data.data.file_url});
					}
					// console.info(that.imgList)
				})
				.catch(err=>{
					console.error(err);
				})
				
			},
			handleRemove(file, fileList){
				let that = this;
				that.imgList.map((k,v)=>{
					if(k.uid == file.uid){
						that.imgList.splice(v,1);
					}
				})
			},
			handleAvatarSuccess(response, file, fileList){
				let that = this;
			},
			handleBeforeUpload(file){
				let that = this;
				// console.info(file)
				return new Promise((resolve,reject)=>{
					if(file.type != 'image/jpeg'&&file.type != 'image/jpg'&&file.type != 'image/png'){
						Message('请上传图片类型!')
						reject();
					}
					if(file.size / 1024 / 1024 > 3){
						Message('图片大小需控制在3M以内!')
						reject()
					}
					resolve()
				})
				
			},
			issueCommit(){
				let that = this;
				if(that.textarea == ''){
					Message('请输入您宝贵的意见哦!');
					return;
				}
				let url = 'api/v1/cloud_pc/app/feedback';
				let arr = that.imgList.map((k,v)=>{
					return k.url;
				});
				let data = {
					content:that.textarea,
					source:1,
					picture_arr:arr,
				};
				that.$req.post(url,data)
				.then(res=>{
					if(res.code === 0){
						that.issueDialogShow = true;
					}else{
						Message(res.msg);
					}
				})
			},
			issueClose(){
				let that = this;
				that.issueDialogShow = false;
				that.imgList = [];
				that.textarea = '';
			},
		},
		beforeDestroy() {
			let that = this;
			that.$bus.$emit('setHeadColor','transparent');
		}
	}
</script>

<style lang="less" scoped>
	.userDetail{
		background-color: rgb(242,242,242);
		.contain{
			width: 100%;
			margin: 0 auto;
			.content{
				width: 1200px;
				margin: 80px auto 0;
				display: flex;
				padding:20px 0;
				.left{
					width: 200px;
					.left-top{
						background-color: #fff;
						padding: 30px 20px;
						text-align: center;
						.top-header{
							width: 78px;
							height: 78px;
							margin: 0 auto;
							position: relative;
							.header-img{
								width: 74px;
								border-radius: 50%;
								border:2px solid #F9DD4A;
							}
							.header-vip{
								position: absolute;
								bottom:-4px;
								width: 72px;
								left: 50%;
								transform: translateX(-50%);
							}
						}
						.name{
							font-size: 20px;
							color:#333;
							border:none;
							background-color:transparent;
							max-width: 160px;
							text-align: center;
							margin: 11px 0 8px;
							font-weight: bold;
							border-bottom: 1px solid transparent;
							text-overflow: ellipsis;
						}
						.phone{
							font-size: 14px;
							color:#666;
							line-height: 20px;
							margin: 8px 0;
						}
						button{
							width: 160px;
							height: 28px;
							line-height: 28px;
							border: none;
							margin-top: 16px;
							border-radius: 14px;
						}
						.cancle-btn{
							border: 1px solid #000;
						}
						.name-edit{
							border-bottom: 1px solid #000;
						}
					}
					.left-select{
						margin-top: 10px;
						background-color: #fff;
						padding-top:21px;
						height: 338px;
						ul{
							li{
								font-size:14px;
								color:#333;
								padding:10px 0 10px 20px;
								border-radius:0px 100px 100px 0px;
								cursor: pointer;
								margin-bottom: 10px;
							}
							.is-select{
								font-weight: 600;
								background: linear-gradient(90deg,rgba(249,221,74,1) 0%,rgba(249,221,74,1) 100%);
							}
						}
		
					}
				}
				.vip-center{
					background-color: #fff;
					margin: 0 10px;
					padding: 30px 20px;
					.center-level{
						display: flex;
						flex-direction: row;
						// background: red;
						.first{
							width: 280px;
							height: 100px;
							font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
							margin-right: 20px;
							position: relative;
							border-radius: 6px;
							background-image: url(../assets/user/vpng2.png);
							background-size: contain;
							img{
								width: 25px;
								height: 25px;
								position: absolute;
								top: 22px;
								left: 16px;
							}
							.title{
								font-size: 16px;
								color: #353535;
								position: absolute;
								top: 24px;
								left: 52px;
								font-family:PingFang SC;
								font-weight:600;
							}
							.time{
								font-size: 16px;
								color: #FA6400;
								position: absolute;
								top: 55px;
								left: 20px;
								font-family: MicrosoftYaHei;
								span{
									font-size: 12px;
								}
							}
							button{
								font-size: 12px;
								background: #FFFFFF;
								width: 80px;
								height: 28px;
								border-radius: 14px;
								color: #99763F;
								position: absolute;
								top: 20px;
								right: 20px;
								font-family: MicrosoftYaHei;
							}
						}
						.first2{
							width: 280px;
							height: 100px;
							// background: #F8F8F8;
							margin-right: 20px;
							position: relative;
							border-radius: 6px;
							background-image: url(../assets/user/vpng1.png);
							background-size: contain;
							img{
								width: 25px;
								height: 25px;
								position: absolute;
								top: 22px;
								left: 16px;
							}
							.title{
								font-size: 16px;
								color: #353535;
								position: absolute;
								top: 24px;
								left: 52px;
								font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
								font-weight:600;
							}
							.time{
								font-size: 16px;
								color: #FA6400;
								position: absolute;
								top: 55px;
								left: 20px;
								span{
									font-size: 12px;
								}
							}
							button{
								font-size: 12px;
								background: #EDCC96;
								width: 80px;
								height: 28px;
								border-radius: 14px;
								color: #353535;
								position: absolute;
								top: 20px;
								right: 20px;
								font-family: MicrosoftYaHei;
							}
						}
						.two{
							width: 280px;
							height: 100px;
							// background: #F8F8F8;
							position: relative;
							border-radius: 6px;
							background-image: url(../assets/user/time.png);
							background-size: contain;
							.title{
								font-size: 16px;
								color: #353535;
								position: absolute;
								top: 25px;
								left: 20px;
								font-family:PingFang SC;
								font-weight:600;
							}
							.time{
								font-size: 16px;
								color: #353535;
								position: absolute;
								top: 55px;
								left: 20px;
								font-weight: bold;
								span{
									font-weight: 400;
									font-size: 12px;
								}
							}
							button{
								font-size: 12px;
								background: #F9DD4A;
								width: 80px;
								height: 28px;
								border-radius: 14px;
								color: #353535;
								position: absolute;
								top: 20px;
								right: 20px;
								font-family: MicrosoftYaHei;
							}
						}
					}
					.privilege-part{
						margin-top: 40px;
						.privilege-title{
							color:#333;
							font-weight: 600;
							font-family:PingFang SC;
							font-size:16px;
							height: 22px;
							line-height: 22px;
						}
						.privilege-group{
							display: flex;
							flex-wrap: wrap;
							width: 640px;
							justify-content: space-between;
						}
						.privilege-item{
							width: 158px;
							height: 90px;
							padding: 20px;
							margin-top: 20px;
							background:#F9F5F2;
							border-radius: 4px;
							
							.item-title{
								font-size: 18px;
								font-family:PingFang SC;
								font-weight:600;
								margin: 0;
							}
							.item-line{
								width: 50px;
								height: 2px;
								background-color: #F9DD4A;
								display: block;
								margin: 10px 0;
							}
							.item-txt{
								p{
									color:#666;
									font-size: 14px;
								}
								.txt-strong{
									font-weight: 600;
									font-family:PingFang SC;
									margin-top: 10px;
									display: flex;
									justify-content: space-between;
									span{
										font-weight: normal;
										text-decoration: line-through;
									}
								}
							}
						}
						.privilege-item:nth-child(1){
							background-image: url(../assets/user/power-bg1.png);
						}
						.privilege-item:nth-child(2){
							background-image: url(../assets/user/power-bg2.png);
						}
						.privilege-item:nth-child(3){
							background-image: url(../assets/user/power-bg3.png);
						}
						.privilege-item:nth-child(4){
							background-image: url(../assets/user/power-bg4.png);
						}
						.privilege-item:nth-child(5){
							background-image: url(../assets/user/power-bg5.png);
						}
						.privilege-item:nth-child(6){
							background-image: url(../assets/user/power-bg6.png);
						}
					}
				}
				.vip-right{
					width: 300px;
					.right-top{
						padding: 30px 20px;
						background-color: #fff;
						.money-txt{
							font-size: #333;
							font-weight: 600;
							font-family:PingFang SC;
						}
						.money{
							text-align: center;
							display: flex;
							align-items: flex-end;
							line-height: 56px;
							justify-content: center;
							margin: 20px 0;
							img{
								width: 24px;
								margin-bottom: 4px;
								margin-right: 10px;
							}
							span{
								color:#F9DD4A;
								font-size: 56px;
								font-weight:bold;
							}
						}
						button{
							width: 100%;
							height: 40px;
							line-height: 40px;
							border-radius:18px;
							margin-top: 15px;
						}
					}
				}
		
				.order{
					margin-left: 10px;
					width: 990px;
					height: 677px;
					.order-select{
						background-color: #fff;
						padding: 0 20px;
						ul{
							display: flex;
							li{
								font-size: 18px;
								margin-right: 80px;
								line-height: 68px;
								cursor: pointer;
							}
							.is-select{
								font-weight: bold;
								border-bottom:3px solid #000;
							}
						}
					}
					.table-btn{
						width: 88px;
						height: 32px;
						border-radius:18px;
					}
					.order-table{
						font-weight: 400px;
						margin-top: 10px;
						background: #fff;
						/deep/
						.el-table::before{
							height: 0px;
						}
						/deep/.el-table__fixed-right::before, .el-table__fixed::before{
							height: 0px;
						}
						.fenye{
							text-align: right;
							margin-top: 21px;
							padding-bottom: 30px;
							/deep/
							.btn-prev{
								background-color: #191919;
							}
							.btn-next{
								background-color: #F9DD4A;
							}
							li.number{
								background-color: unset;
								color: #191919;
								font-size: 16px;
								font-family:PingFang SC;
								font-weight:600;
							}
							li.number.active{
								// background-color: unset;
								color: #F9DD4A;
							}
							/deep/
							.el-pager li:not(.disabled).active{
								background-color: #F9DD4A;
							}
						}
					}
					.el-table .odd-li{
						font-size: 14px;
						font-weight: 400;
						background-color: #FFFFFF;
						color:#000000 ;
					}
					.el-table .even-li{
						font-size: 14px;
						font-weight: 400;
						background-color: #F9F9FA;
						color:#000000;
					}
					.el-table th, .el-table tr{
						background-color: #F9F9FA;
					}
					.header-row{
						background-color: #F9F9FA;
						color:#666 ;
						font-size: 14px;
					}
					.cell-class{
						height: 64px;
						line-height: 64px;
					}
					.no-pay{
						// color:#FA6400;
						color:#999999;
					}
					.has-pay{
						color:#FA6400;
					}
					.label-class-name{
						// background-color: #F9F9FA;
						color:#666;
					}
					.handle-label{
						text-align: left;
						padding-right: 30px;
						padding-left: 20px;
					}
				}
				.record{
					margin-left: 10px;
					width: 990px;
					height: 677px;
					background:rgba(255,255,255,1);
					opacity:1;
					border-radius:4px;
					.header-row{
						// background-color: #F9F9FA;
						color:#666 ;
						font-size: 14px;
					}
					.cell-class{
						height: 64px;
						line-height: 64px;
					}
					/deep/
					.el-table th{
						background-color: #F9F9FA;
					}
					.fenye{
						text-align: right;
						margin-top: 30px;
						padding-bottom: 30px;
						/deep/
						.btn-prev{
							background-color: #191919;
						}
						.btn-next{
							background-color: #F9DD4A;
						}
						li.number{
							background-color: unset;
							color: #191919;
							font-size: 16px;
							font-family:PingFang SC;
							font-weight:600;
						}
						li.number.active{
							// background-color: unset;
							color: #F9DD4A;
						}
						/deep/
						.el-pager li:not(.disabled).active{
							background-color: #F9DD4A;
						}
					}
				}
				.issue{
					margin-left: 10px;
					width: 990px;
					height: 677px;
					background:rgba(255,255,255,1);
					opacity:1;
					border-radius:4px;
					padding: 0 20px;
					.title{
						display: flex;
						margin-top: 30px;
						align-items: baseline;
						.left{
							width:90px;
							height:28px;
							font-size:20px;
							font-family:PingFang SC;
							font-weight:600;
							line-height:28px;
							color:rgba(51,51,51,1);
						}
						.right{
							margin-left: 15px;
							width:200px;
							height:20px;
							font-size:14px;
							font-family:PingFang SC;
							font-weight:400;
							line-height:20px;
							color:rgba(153,153,153,1);
						}
					}
					.label{
						margin-top: 30px;
						width:100px;
						height:22px;
						font-size:16px;
						font-family:PingFang SC;
						font-weight:600;
						line-height:22px;
						color:rgba(51,51,51,1);
						border-left: rgba(249,221,74,1) 4px solid;
						text-indent: 10px;
					}
					.text{
						margin-top: 25px;
						width:950px;
						height:200px;
						/deep/
						.el-textarea__inner{
							padding: 20px;
							overflow-y: auto;
						}
						.el-textarea__inner:focus{
							border-color: #C0C4CC;
						}
					}
					.upload{
						margin-top: 20px;
						width:950px;
						/deep/
						.el-upload--picture-card{
							width: 80px;
							height: 80px;
							line-height: 85px;
						}
						/deep/
						.el-upload-list--picture-card .el-upload-list__item{
							width: 80px;
							height: 80px;
						}
					}
					.btn{
						margin-top: 40px;
						width:950px;
						.btns{
							width:179px;
							height:48px;
							background:rgba(249,221,74,1);
							opacity:1;
							border-radius:24px;
							font-size:14px;
							font-family:PingFang SC;
							font-weight:400;
							color:rgba(51,51,51,1);
							padding: 14px 75px;
							border-color:rgba(249,221,74,1) ;
						}
					}
				}
			}
		}
		.foot{
				margin-top: 170px;
				height:440px;
				background:rgba(13,13,13,1);
				border-top: 2px solid rgba(249,221,74,1);;
				.footImg{
					width: 136px;
					height: 116px;
					vertical-align: middle;
					position: absolute;
					transform: translate(250px, -116px)
				}
				.footInfo{
					width: 70%;
					max-width: 1200px;
					margin:40px auto;
					display: flex;
					justify-content: space-between;
					font-family:MicrosoftYaHei;
					color:rgba(164,164,164,1);
					.left{
						
					}
					.right{
						font-size: 15px;
						display: flex;
					}
				}
				.footText{
					width: 70%;
					max-width: 1200px;
					height: 100px;
					line-height: 100px;
					margin: 0 auto;
					font-family: MicrosoftYaHei;
					color:#606268;
					text-indent: 250px;
					border-top: 1px solid #606268;
				}
			}
			
			.duihuanDialog{
				/deep/
				.el-dialog__body{
					padding: 0;
				}
				.dialog_title{
					background: url(../assets/user/dialog_bg_xiao@2x.png) no-repeat  center;
					background-size: cover;
					height: 85px;
					border-radius:22px 22px 0px 0px;
					display: flex;
					position: absolute;
					width: 100%;
					z-index: 99;
					.left{
						flex: 1;
						.el-image{
							width: 120px;
							height: 125px;
							vertical-align: middle;
							position: relative;
							transform: translate(18px, -45px);
						}
					}
					.mind{
						flex: 3;
						font-size:26px;
						font-family:PingFang SC;
						font-weight:600;
						color:rgba(13,13,13,1);
						line-height:85px;
						display: inline-block;
						text-align: left;
						text-indent: 70px;
					}
				}
				
				.closeRight{
					width: 50px;
					height: 85px;
					.right_div{
						width: 80px;
						height: 120px;
						background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAAB4CAMAAABSMIXEAAAAb1BMVEUAAAD/swDouQD4tgD4tAD4tQD2tAD2tAD2twD3tQD3tQD4tQD3tQD4tgD3tQD4tQD4tQD3tQD4tQD4tQD4tQD2rQD2sAD3tQD3tgX3tgb3uA33vBv50F760WD75KX85qr87cX87sb++u/+/fn///+OC2rxAAAAFXRSTlMACgsjR0hSWFiDhpWosbrQ1+vx9vh7dOKjAAABTUlEQVRo3u3a2a7CIBAGYLf21Lp1UX/FDXXe/xnPhUsoaROpf3I4ycwlIV8IMHAxM0DvWJfFIp8MB17gy6jnCRcEsErJILAck0FUP2QQmLJBzNjga408EBkbrMZkEEs2iJQNrtggEjY4Z4P1iAxiwgZzNrgIAXfn28W4A+ZyO++ac4oQ8Cgi1hGNFZFjc04ZAp6kIRorInLyfq4QcG9d8eHZvTcp6FCMIxor3g70AB2lywsE306nFwo+xeu1ywsGn2KnFw6+xXavB4jDXUTkfgDiXCF7D9mnzL6H7Exh5zL9tfnkPQT7xQb7TwH711NQQQUVVFBBBRVUUMF4wO2mJbZfgJvWiGmFem0U1EzRU1ZQM+VfZ8qaDZZssPjTEtInkcdehquHsZcyk9jLwWnkJXV60T+LvHFiFnfzSZVF3cDDbTEiNkE92rRGXpfWL5RrVDuaKhuBAAAAAElFTkSuQmCC) no-repeat center;
						background-size: cover;
						border-radius: 0px 17px 17px 0px;
						display: inline-block;
						position: relative;
						-webkit-transform: translate(598px, -2px);
						transform: translate(598px, -2px);
						cursor: pointer;
						z-index: -1;
					}
				}
				.contain{
					height: 280px;
					.text{
						width: 528px;
						margin: 80px auto 0 auto;
						height: 78px;
						line-height: 78px;
						border:1px solid rgba(224,224,224,1);
						border-radius: 60px;
						color:rgba(13,13,13,1);
						/deep/
						.el-input__inner{
							width: 438px;
							border:unset;
							font-size:22px;
							font-family:PingFang SC;
							font-weight:400;
							// color:rgba(13,13,13,1);
							margin-left: 50px;
							border: none;
						}
						.el-input__inner::-moz-input-placeholder,
						.el-input__inner::-ms-input-placeholder,
						.el-input__inner::-webkit-input-placeholder{
							font-size:22px;
							font-family:PingFang SC;
							font-weight:400;
							color:rgba(153,153,153,1);
						}
						/deep/input::-moz-input-placeholder,
						/deep/input::-ms-input-placeholder,
						/deep/input::-webkit-input-placeholder{
							font-size:22px;
							font-family:PingFang SC;
							font-weight:400;
							color:rgba(153,153,153,1);
							
						}
					}
					.btns{
						margin: 51px auto 0 auto;
						width: 528px;
						.btn1{
							width:254px;
							height:78px;
							background:rgba(248,248,248,1);
							border-color:rgba(248,248,248,1);
							opacity:1;
							border-radius:39px;
							height: 78px;
							font-size:22px;
							font-family:MicrosoftYaHei;
							
							color:rgba(13,13,13,1);
						}
						.btn2{
							width:254px;
							height:78px;
							background:rgba(249,221,74,1);
							border-color:rgba(249,221,74,1);
							opacity:1;
							border-radius:39px;
							height: 78px;
							font-size:22px;
							font-family:MicrosoftYaHei;
							color:rgba(13,13,13,1);
						}
					}
				}
			}
			
			.scOrderDialog{
				.btns{
					 margin-top: 50px;
					.btn1{
						width:214px;
						height:78px;
						background:rgba(248,248,248,1);
						border-color:rgba(248,248,248,1);
						opacity:1;
						border-radius:39px;
						height: 78px;
						font-size:22px;
						font-family:MicrosoftYaHei;
						color:rgba(13,13,13,1);
					}
					.btn2{
						width:214px;
						height:78px;
						background:rgba(249,221,74,1);
						border-color:rgba(249,221,74,1);
						opacity:1;
						border-radius:39px;
						height: 78px;
						font-size:22px;
						font-family:MicrosoftYaHei;
						color:rgba(13,13,13,1);
					}
				}	
			}
			
			.issueDialog{
				.btns{
					.btn2{
						margin: 50px auto 0 auto;
						width:328px;
						height:78px;
						background:rgba(249,221,74,1);
						opacity:1;
						border-radius:39px;
						font-size:22px;
						font-family:MicrosoftYaHei;
						line-height:26px;
						color:rgba(13,13,13,1);
						border-color: rgba(249,221,74,1);
					}
				}
			}
	}
	input, input:focus ,button,button:focus{
		outline: none;
		border: none;
	}
	ul,li,p{ padding:0;margin:0;list-style:none}
	.bg-black{
		background-color: #000000;
	}
	.bg-yellow{
		background-color: #F9DD4A;
	}
	.bg-transparent{
		background-color:transparent;
	}
	.color-yellow{
		color:#F9DD4A;
	}
	button{
		cursor: pointer;
	}
	.el-table__body-wrapper::-webkit-scrollbar{
		width : 7px;  /*高宽分别对应横竖滚动条的尺寸*/
		height: 10px;
	}
	.el-table__body-wrapper::-webkit-scrollbar-thumb {
		/*滚动条里面小方块*/
		border-radius   : 10px;
		background-color: rgb(168,168,168);
		background-image: -webkit-linear-gradient(
			45deg,
			rgba(255, 255, 255, 0.2) 25%,
			transparent 25%,
			transparent 50%,
			rgba(255, 255, 255, 0.2) 50%,
			rgba(255, 255, 255, 0.2) 75%,
			transparent 75%,
			transparent
		);
	}
	.el-table__body-wrapper::-webkit-scrollbar-track {
		/*滚动条里面轨道*/
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #ededed;
		border-radius: 10px;
	}
</style>
